<template lang='pug'>
.quill-editor-wrapper
  #toolbar-container.ql-toolbar.ql-snow
    span.ql-formats
      select.ql-font
      select.ql-size
    span.ql-formats
      button.ql-bold
      button.ql-italic
      button.ql-underline
      button.ql-strike
    span.ql-formats
      select.ql-color
      select.ql-background
    span.ql-formats
      button.ql-script(value='sub')
      button.ql-script(value='super')
    span.ql-formats
      button.ql-header(value='1')
      button.ql-header(value='2')
      button.ql-blockquote
      button.ql-code-block
    span.ql-formats
      button.ql-list(value='ordered')
      button.ql-list(value='bullet')
      button.ql-indent(value='-1')
      button.ql-indent(value='+1')
    span.ql-formats
      button.ql-direction(value='rtl')
      select.ql-align
    span.ql-formats
      button.ql-link
      button.ql-image
      button.ql-video
      button.ql-formula
    span.ql-formats
      button.ql-clean
  #quill-editor.ql-container.ql-snow
</template>

<script>
export default {
  data() {
    return {
      privacyPolicyData: {}
    }
  },
  props: ['privacyPolicy'],
  created() {
    const parsedPrivacyPolicy = JSON.parse(this.privacyPolicy)
    for (let key in parsedPrivacyPolicy) {
      this.privacyPolicyData[key] = parsedPrivacyPolicy[key]
    }
  },
  mounted() {
    const quill = new Quill('#quill-editor', {
      modules: {
        toolbar: '#toolbar-container',
      },
      theme: 'snow'
    })

    quill.on('text-change', (_delta, _oldDelta, _source) => {
      this.privacyPolicyData.body = quill.root.innerHTML
      document.getElementById('user_privacy_policy').value = JSON.stringify(this.privacyPolicyData)
    })

    if (this.privacyPolicyData?.body) {
      quill.clipboard.dangerouslyPasteHTML(this.privacyPolicyData.body)
    }
  },
  methods: {
  }
}
</script>
